import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";

export interface IDeleteClientModelMutation {
  model_id: string;
}

export const useDeleteClientModel = () => {
  return useMutation({
    mutationFn: (props: IDeleteClientModelMutation) =>
      axios
        .delete(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${props.model_id}`,
          {}
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
